import { Maybe } from "../models/generated/graphql";

export const splitName = (name: Maybe<string> | undefined) => (name ? name.split(/[\s,]/) : []);

export const nameToInitials = (name: Maybe<string>) =>
	name &&
	splitName(name)
		.map((c) => c[0])
		.join(" ")
		.replace(/\s/g, "");
